module.exports = __webpack_public_path__ + "static/media/feedback_survey.725ad1b3.svg";